import React from "react";
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import HomePage from "../components/HomePage";
import LoginPage from "../components/LoginPage";
import Courses from "../components/Courses";
import ContactUs from "../components/ContactUs";
import AboutUs from "../components/AboutUs";
import ScrollToTop from "./ScrollToTop"; // Import the ScrollToTop component
import DashboardTemp from "../components/DashboardTemp";
import MyCourses from "../components/MyCourses";
import MyProfile from "../components/MyProfile";
import MyDownloads from "../components/MyDownloads";
import IndividualCourse from "../components/IndividualCourse";

const AppRouter = () => (
    <BrowserRouter>
        <div>
            <ScrollToTop />  {/*Add the ScrollToTop component */}
            <Routes>
                <Route path="/" exact={true} element={<HomePage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/courses" element={<Courses />} />
                <Route path="/contactus" element={<ContactUs />} />
                <Route path="/aboutus" element={<AboutUs />} />
                <Route path= "/my" element={<DashboardTemp/>} ></Route>
                <Route path= "/user/courses" element={<MyCourses/>} ></Route>
                <Route path= "/user/profile" element={<MyProfile/>} ></Route>
                <Route path= "/user/downloads" element={<MyDownloads/>} ></Route>
                <Route path= "/course/:id" element={<IndividualCourse/>}></Route>
                {/* <Route component={NotFoundFage} /> */}
            </Routes>
        </div>
    </BrowserRouter>
);

export default AppRouter;
